import { render, staticRenderFns } from "./CommentPanel.vue?vue&type=template&id=aa923966&scoped=true&"
import script from "./CommentPanel.vue?vue&type=script&lang=js&"
export * from "./CommentPanel.vue?vue&type=script&lang=js&"
import style0 from "./CommentPanel.vue?vue&type=style&index=0&id=aa923966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa923966",
  null
  
)

export default component.exports